import { render, staticRenderFns } from "./Course-breadcrumb.vue?vue&type=template&id=422e7102"
import script from "./Course-breadcrumb.vue?vue&type=script&lang=js"
export * from "./Course-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports